import { lazy } from 'react'
import { MasukRoute } from './MasukRoute'

export { MasukLayout } from './MasukLayout'

// The layout and the guard stay in the shell entry; the screens (input-otp, react-hook-form)
// arrive in one chunk. Nearly every launch passes through a sign-in step (the PIN after
// every relaunch), so the chunk starts loading with the app instead of when the route
// renders; otherwise the card grew under the settled splash and shifted the layout.
let muat: Promise<typeof import('./layar')> | null = null
const layar = () => {
  muat ??= import('./layar')
  return muat
}
// Prefetched two seconds after launch, once the first screen has painted, so the download
// never competes with the first paint.
if (typeof window !== 'undefined') window.setTimeout(() => void layar(), 2000)

// The login form itself is in the entry: it is the first screen of a new or signed-out device,
// and waiting for a lazy chunk added a round trip before its first paint on slow links.
export const MasukLazy = MasukRoute
export const PinLazy = lazy(() => layar().then((m) => ({ default: m.PinRoute })))
export const BuatPinLazy = lazy(() => layar().then((m) => ({ default: m.BuatPinRoute })))
export const LupaPinLazy = lazy(() => layar().then((m) => ({ default: m.LupaPinRoute })))
export const UnduhanPertamaLazy = lazy(() =>
  layar().then((m) => ({ default: m.UnduhanPertamaRoute })),
)
// Akun & keamanan (spec 2026-09-30): the steps after the password and the e-mail pages, in
// the same chunk.
export const SandiAwalLazy = lazy(() => layar().then((m) => ({ default: m.SandiAwalRoute })))
export const DuaLangkahLazy = lazy(() => layar().then((m) => ({ default: m.DuaLangkahRoute })))
export const LupaSandiLazy = lazy(() => layar().then((m) => ({ default: m.LupaSandiRoute })))
export const SandiBaruLazy = lazy(() => layar().then((m) => ({ default: m.SandiBaruRoute })))
export const KonfirmasiEmailLazy = lazy(() =>
  layar().then((m) => ({ default: m.KonfirmasiEmailRoute })),
)
